import React, { useState, useEffect } from "react";
import { FaSave, FaTrash, FaPlus } from "react-icons/fa";
import { createUsers, updateOrder, deleteItems, getCustomers, deleteCustomers, createCustomers, updateCustomers } from "../api";

import dropdownData from "../data/dropdownData.json";
const UpdateCustomerData = () => {
  const [data, setData] = useState(dropdownData.customers);

  const [editedData, setEditedData] = useState({});
  const [newRow, setNewRow] = useState({ name: "", phone: "" });

  const handleChange = (id, field, value) => {
    setEditedData((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        [field]: value,
      },
    }));
  };

  const handleSave = (id) => {
    const updated = data.map((item) =>
      item.id === id ? { ...item, ...editedData[id] } : item
    );
    setData(updated);
    setEditedData((prev) => {
      const copy = { ...prev };
      delete copy[id];
      return copy;
    });
    console.log("update ", id, updated[id - 1]);
    updateCustomers(id, updated.filter((user) => user.id === id)[0])
      .then(() => {
        alert('Customer updated successfully');
        console.log("Customer updated successfully");
      })
      .catch((error) => {
        alert('Error updating Customer');
        console.error("Error updating Customer:", error);
      });
  };

  const handleDelete = (id) => {
    const filtered = data.filter((item) => item.id !== id);
    setData(filtered);
    setEditedData((prev) => {
      const copy = { ...prev };
      delete copy[id];
      return copy;
    });
    console.log("deleted ", id);
    deleteCustomers(id)
      .then(() => {
        alert("Customer deleted successfully");
        console.log("Customer deleted successfully");
      })
      .catch((error) => {
        alert("Error deleting Customer");
        console.error("Error deleting Customer:", error);
      });
  };

  const handleNewRowChange = (field, value) => {
    setNewRow((prev) => ({ ...prev, [field]: value }));
  };

  const handleAddRow = () => {
    if (!newRow.name.trim() || !newRow.phone.trim()) return;

    const nextId = data.length ? Math.max(...data.map((d) => d.id)) + 1 : 1;
    setData([...data, { id: nextId, ...newRow }]);
    setNewRow({ name: "", phone: "" });
    console.log("add ", nextId, newRow);
    createCustomers(newRow)
      .then(() => {
        alert("Customer added successfully");
        console.log("Customer added successfully");
      })
      .catch((error) => {
        alert("Error adding Customer");
        console.error("Error adding Customer:", error);
      });
  };

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getCustomers()
      .then((res) => {
        setData(res.data); setLoading(false);
      })
      .catch((err) => {
        console.error('Error fetching Customers:', err);
        setLoading(false);
      });
  }, []);

  if (loading) return <p>Loading...</p>;

  return (
    <div className="p-6 max-w-5xl mx-auto">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-bold">Editable Contacts Table</h2>
      </div>

      <table className="w-full table-auto border border-gray-300">
        <thead className="bg-gray-100">
          <tr>
            <th className="border px-4 py-2">ID</th>
            <th className="border px-4 py-2">Phone</th>
            <th className="border px-4 py-2">Name</th>
            <th className="border px-4 py-2">Actions</th>
          </tr>
        </thead>
        <tbody>
          {data.map(({ id, phone, name }) => (
            <tr key={id}>
              <td className="border px-4 py-2 text-center">{id}</td>
              <td className="border px-4 py-2">
                <input
                  type="text"
                  value={editedData[id]?.phone ?? phone}
                  onChange={(e) => handleChange(id, "phone", e.target.value)}
                  className="w-full px-2 py-1 border rounded"
                />
              </td>
              <td className="border px-4 py-2">
                <input
                  type="text"
                  value={editedData[id]?.name ?? name}
                  onChange={(e) => handleChange(id, "name", e.target.value)}
                  className="w-full px-2 py-1 border rounded"
                />
              </td>
              <td className="border px-4 py-2 flex justify-center gap-4">
                <button
                  className="text-green-600 hover:text-green-800"
                  onClick={() => handleSave(id)}
                  title="Save"
                >
                  <FaSave />
                </button>
                <button
                  className="text-red-600 hover:text-red-800"
                  onClick={() => handleDelete(id)}
                  title="Delete"
                >
                  <FaTrash />
                </button>
              </td>
            </tr>
          ))}

          {/* New Row Input */}
          <tr>
            <td className="border px-4 py-2 text-center">—</td>
            <td className="border px-4 py-2">
              <input
                type="text"
                value={newRow.phone}
                onChange={(e) => handleNewRowChange("phone", e.target.value)}
                className="w-full px-2 py-1 border rounded"
                placeholder="Enter phone"
              />
            </td>
            <td className="border px-4 py-2">
              <input
                type="text"
                value={newRow.name}
                onChange={(e) => handleNewRowChange("name", e.target.value)}
                className="w-full px-2 py-1 border rounded"
                placeholder="Enter name"
              />
            </td>
            <td className="border px-4 py-2 text-center text-gray-500 italic">
              <button
                className="flex items-center gap-2 px-4 py-2 rounded hover:bg-blue-700"
                onClick={handleAddRow}
              >
                <FaPlus /> Add Row
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default UpdateCustomerData;
